<template>
    <div>
        <el-card class="box-card">
            <el-tabs v-model="activeName">
                <el-tab-pane  label="转账任务" name="first">
                    <div>
                    <el-row :gutter="20">
                        <el-col :span="24" >
                              <el-alert
                              :closable="false"
                              style="margin-top:-5px;margin-bottom:5px"
                                :title="'共计 '+waitModel.count+' 笔，'+-waitModel.sum+' 元'"
                                type="error"   center>
                            </el-alert>
                            <el-card class="box-card">
                                <el-table
                                v-loading="isLoading"
                                :data="tableData"
                                :height="bodyHeight-60"
                                style="width: 100%">
                                    <el-table-column
                                        label="姓名"
                                        width="100">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                {{scope.row.Name}}
                                            </template>
                                            <template v-else>
                                                ***
                                            </template>
                                        </template>
                                    </el-table-column>
                                        
                                    <el-table-column
                                        width="130"
                                        prop="Phone"
                                        label="手机">
                                    </el-table-column>
                                    <el-table-column
                                    width="100"
                                        label="收款码">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                <el-link target="_blank"  @click="wechatPay(scope.row)" type="primary">点击查看</el-link>
                                            </template>
                                            <template v-else>
                                                <el-link target="_blank"  type="primary">请先确认</el-link>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="BankAccountName"
                                        label="开户行">
                                    </el-table-column>
                                    <el-table-column
                                        label="银行卡号">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                <el-link @click="copy(scope.row)" icon="el-icon-copy-document" type="primary">{{scope.row.BankCardNo}}</el-link>
                                            </template>
                                            <template v-else>
                                                <el-link  icon="el-icon-copy-document" type="primary">*********</el-link>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="140"
                                        label="金额">
                                        <template slot-scope="scope">
                                            <el-tag class="tag_btn" size="mini" type="danger" effect="dark">￥{{scope.row.Money}}</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="100"
                                        label="状态">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                <el-tag size="mini" effect="plain" v-if="scope.row.Status==2">待审核</el-tag>
                                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==1">成功</el-tag>
                                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==3">失败</el-tag>
                                            </template>
                                            <template v-else>
                                                <el-tag size="mini" type="warning" effect="plain" v-if="scope.row.Status==2">待确认</el-tag>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="160"
                                        prop="CreateTime"
                                        label="提现时间">
                                    </el-table-column>
                                    <el-table-column
                                    width="">
                                    <template slot="header">
                                        <el-tooltip class="item"  effect="dark" content="刷新任务" placement="bottom">
                                            <el-button size="mini" type="primary" @click="query" icon="el-icon-refresh" circle></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item"  effect="dark" content="下载已确认任务" placement="bottom">
                                        <el-button size="mini" type="" @click="getExl" icon="el-icon-download" circle></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item"  effect="dark" content="批量审核通过" placement="bottom">
                                        <el-button size="mini" type="danger" @click="shanchuan" icon="el-icon-upload2" circle></el-button>
                                        </el-tooltip>
                                        
                                        <input type="file" ref="uploadExcel" v-show="false" accept=".xls,.xlsx" @change="readExcel">
                                    </template>
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                <template v-if="scope.row.Status==2">
                                                    <el-button @click="wechatPayPass(scope.row)" type="" size="mini">微信</el-button>
                                                    <el-button @click="pass(scope.row)" type="primary" size="mini">银行卡</el-button>
                                                    <!-- <el-button @click="over(scope.row)" type="danger" size="mini">失败</el-button> -->
                                                </template>
                                            </template>
                                            <template v-else>
                                                <el-tooltip class="item"  effect="dark" content="确认打款任务" placement="bottom">
                                                    <el-button type="primary"  size="mini" @click="comfrim(scope.row)"  icon="el-icon-check" circle></el-button>
                                                </el-tooltip>  
                                            </template>               
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>
                        </el-col>
                    </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="历史记录" name="second">
                    <div  >
                <el-card class="box-card"  >
                    <div slot="header" class="clearfix">
                        <el-button type="success" @click="getRecordExl" icon="el-icon-download" size="small" plain>导出结果</el-button>

                         <el-input
                            size="small"
                            style="width:200px;margin-left:20px"
                            placeholder="请输入用户 姓名/手机号"
                            prefix-icon="el-icon-search"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="审批状态">
                            <el-option key="1" label="成功" value="1"> </el-option>
                            <el-option key="3" label="失败" value="3"> </el-option>
                        </el-select>
                        <el-date-picker
                        :clearable="false"
                        size="small" 
                        style="width:250px;margin-left:20px"
                        v-model="queryModel.times"
                        type="daterange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="queryRecord" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>

                        <el-tag size="" style="margin-left:10px">共计：{{-okSum}} 元</el-tag>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoadingRecord"
                    :height="bodyHeight-90"
                    :data="recordData"
                    style="width: 100%">
                                    <el-table-column
                                        width="100"
                                        prop="Name"
                                        label="姓名">
                                    </el-table-column>
                                    <el-table-column
                                        width="130"
                                        prop="Phone"
                                        label="手机">
                                    </el-table-column>
                                    <el-table-column
                                    width="100"
                                        label="收款码">
                                        <template slot-scope="scope">
                                            <el-link target="_blank"  @click="wechatPay(scope.row)" type="primary">点击查看</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="BankAccountName"
                                        label="开户行">
                                    </el-table-column>
                                    <el-table-column
                                        label="银行卡号">
                                        <template slot-scope="scope">
                                            <el-link @click="copy(scope.row)" icon="el-icon-copy-document" type="primary">{{scope.row.BankCardNo}}</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="140"
                                        label="金额">
                                        <template slot-scope="scope">
                                            <el-tag class="tag_btn" size="mini" type="danger" effect="dark">￥{{scope.row.Money}}</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="100"
                                    label="转款方式">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.PayType==1"  size="mini"  effect="dark">
                                            银行卡
                                        </el-tag>
                                         <el-tag  size="mini" v-else-if="scope.row.PayType==2"  effect="dark">
                                            微信
                                        </el-tag>
                                        <el-tag  size="mini" v-else  effect="dark">
                                            无
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                    <el-table-column
                                    width="80"
                                        label="状态">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.IsConfirm">
                                                <el-tag size="mini" effect="plain" v-if="scope.row.Status==2">待审核</el-tag>
                                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==1">成功</el-tag>
                                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==3">失败</el-tag>
                                            </template>
                                            <template v-else>
                                                <el-tag size="mini" type="warning" effect="plain" v-if="scope.row.Status==2">待确认</el-tag>
                                            </template>
                                            
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="160"
                                        prop="CreateTime"
                                        label="提现时间">
                                    </el-table-column>
                                    <el-table-column
                                    width="160"
                                        prop="ReviewTime"
                                        label="审核时间">
                                    </el-table-column>
                        
                    </el-table>
                </el-card>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <el-image-viewer 
                style="z-index:999999"
                v-if="showViewer" 
                :on-close="closeImg" 
                :url-list="[img]" />
    </div>
</template>
<script>

import {uri,billGetMyWithdraw,billReview,billPassBatch,billConfrim,billGet,billHeartbeat} from '@/request.js'
import XLSX from 'xlsx'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'App',
  components: {
      ElImageViewer
  },
    props:{
      isOnLine:{
        type:Boolean,
        required: true
      },
      outsider:{
        type:Object,
        required: true
      },
    },
  data() {
    return {
        bodyHeight:0,
         activeName: 'first',
         tableData:[],
         isLoading:false,
         isLoadingRecord:false,
         queryModel:{
            queryTxt:"",
            status:"",
            times:[],
            pSize:20,
            pIndex:1,
         },
         total:0,
         recordData:[],
         showViewer:false,
         img:"",
         waitModel:{
             count:0,
             sum:0,
         },
         okSum:0,
         timer:{},
    };
  },
  watch:{
  },
  created() {
    this.bodyHeight=document.documentElement.clientHeight-220;
  },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
  mounted() {
        var date=new Date();
        this.queryModel.times.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.times.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
      this.query();
      this.queryRecord();
      this.timer= setInterval(() => {
          if(this.isOnLine){
              billHeartbeat({},()=>{

              });
          }
      }, 10000);
  },
   methods:{
       queryRecord(){
           this.isLoadingRecord=true;
           billGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                times:this.queryModel.times==null?"[]":JSON.stringify(this.queryModel.times),
           },(res)=>{
               this.recordData=res.Result.List;
               this.total=res.TotalCount;
               this.okSum=res.Result.Sum;
               this.isLoadingRecord=false;
           })
       },
       query(){
           this.isLoading=true;
           billGetMyWithdraw({},(res)=>{
               this.tableData=res.Result.List;
               this.waitModel.count=res.Result.Count;
               this.waitModel.sum=res.Result.Sum;
               console.log(this.waitModel)
               this.isLoading=false;
           })
       },
        readExcel(e) {
            this.isLoading=true;
            const files = e.target.files;
            if (files.length <= 0) {
                this.isLoading=false;
                //如果没有文件名
                return false;
            }
            const fileReader = new FileReader();
            var ids="";
            fileReader.onload = ev => {
            try {
                const data = ev.target.result;
                const workbook = XLSX.read(data, {
                    type: "binary"
                });
                const wsname = workbook.SheetNames[0]; //取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                
                ws.forEach((value) => {
                    if(value.Id){
                        ids+=value.Id.toString().trim()+",";
                    }
                })
                } catch (e) {
                    console.log(e)
                }
               ids=ids.substring(0,ids.length-1);
               console.log(ids);
               billPassBatch({ids:ids},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                });   
            };
            fileReader.readAsBinaryString(files[0]);
                 
        },
        comfrim(scope){
            billConfrim({id:scope.Id},(res)=>{
                if(res.IsSuccess){
                    scope.IsConfirm=true;
                }
            });
        },
        shanchuan(){
            this.$refs.uploadExcel.click();
        },
        getExl(){
           window.open(uri+"/Bill/GetMyWithdrawExl?managerId="+this.outsider.Id)
        },
         getRecordExl(){
           window.open(uri+"/bill/GetExl?outsiderId="+this.outsider.Id+"&queryTxt="+this.queryModel.queryTxt+"&status="+(this.queryModel.status==""?0:parseInt(this.queryModel.status))+"&times="+(this.queryModel.times==null?"[]":JSON.stringify(this.queryModel.times))
           );
       },
              closeImg(){
            this.showViewer=false;
        },
        wechatPayPass(scope){
                billReview({id:scope.Id,status:1,payType:2,wechatOrder:""},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '提现成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
        },
        wechatPay(scope){
            this.img=scope.CollectionCode;
            this.showViewer=true;
        },

        copy(scope){
            this.$copyText(scope.BankCardNo).then(function () {
            }, function (e) {
                console.log(e);
            })
        },
        pass(scope){
            this.$confirm('确认该提现申请已银行卡转款吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                billReview({id:scope.Id,status:1,payType:1},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '提现成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
     
            });
        },
        over(scope){
            this.$confirm('确认拒绝该提现申请吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                billReview({id:scope.Id,status:3},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
      
            });
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.queryRecord();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.queryRecord();
        }
   },
}
</script>
<style >
.el-card__body{
   padding: 20px; 
   padding-top: 10px;
}
</style>